export { default as en } from './lib/en.json';
export { default as fr } from './lib/fr.json';
